import React from "react";

const PageNotFound = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      {/* Add any additional content or navigation links here */}
    </div>
  );
};

export default PageNotFound;
